import { addNamespace } from '@muz/jobboard-vue-client/src/store/helper/namespace';

const namespace = 'SelectedJobAd';

const Types = {
    mutations: {
        SET_JOB_AD: 'setJobAd',
        SET_COMPANY_ID: 'setCompanyId',
    },
};

export const LocalTypes = {
    ...Types,
    namespace,
};

export default {
    ...addNamespace(namespace, Types),
    namespace,
};
